import { render, staticRenderFns } from "./ClickAndBuyTitleForm.vue?vue&type=template&id=298ded44&scoped=true"
import script from "./ClickAndBuyTitleForm.vue?vue&type=script&lang=js"
export * from "./ClickAndBuyTitleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298ded44",
  null
  
)

export default component.exports